
import { Component, OnInit,EventEmitter, ViewChild } from "@angular/core";
import {  ConfirmationService, MessageService } from "primeng/api";
import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';
import { ConsultaOrdenesTrabajo, ConsultaOrdenesTrabajoInput, EtapasOrdenes, SolicitudesJson, SolicitudDetalles, SolicitudEtapaTramites, Solicitudes, CancelaSolicitudInput, AuxJasper, ParametroJasper, GuardaFoliosOrdenes } from '../../entidades/entidades';
import { ConsultaOrdenesTrabajoService } from "app/servicios/ordenes-trabajo.service";
import { AuthenticationService } from "app/servicios";
import { FlujoOrdenesService } from "../../servicios/flujo-ordenes.service";
import { RegistraSolicitudesService } from "../../servicios/registra-solicitudes.service"
import { SolicitudesService } from "app/servicios/solicitudes.service";
import { CancelaSolicitudService } from "../../servicios/cancela-solicitud.service";
import { OrdenesTrabajoFlujoComponent } from "../ordenes-trabajo-flujo/ordenes-trabajo-flujo.component";
import { OrdenesTrabajoComponent } from "../ordenes-trabajo/ordenes-trabajo.component";
import { GuardaFoliosOrdenesService } from "app/servicios/guarda-folios-ordenes.service";
@Component({
  selector: "app-consulta-ordenes-trabajo-grid",
  templateUrl: "./generar-orden-trabajo.component.html",
  styleUrls: ["./generar-orden-trabajo.component.css"],
  providers: [MessageService],
})
export class GenerarOrdenTrabajoComponent implements OnInit {
  
  public  etapasOrdenesInput$ = new EventEmitter<EtapasOrdenes[]>();
  public  ConsultaOrdenesInput$ = new EventEmitter<ConsultaOrdenesTrabajo[]>();
  public  RefreshOrdenesInpunt$ = new EventEmitter<EtapasOrdenes[]>(); 
  
  @ViewChild(OrdenesTrabajoFlujoComponent, { static: false }) childOrdenesTrabajoFlujoComponent;
  @ViewChild(OrdenesTrabajoComponent, { static: false }) childOrdenesTrabajoComponent;
  
  //entidad principal
  public consultaOrdenesTrabajo: ConsultaOrdenesTrabajo[] = [];
  public consultaOrdenesTrabajoCloned: ConsultaOrdenesTrabajo[] = [];
  public OrdenTrabajo: ConsultaOrdenesTrabajo 
  progressBar: boolean = false;
  Solicitud: Solicitudes; 
  //instancias
  public muestraMensaje = new MuestraMensaje();
  
  //entidad de paso
  public EtapasOrdenes: EtapasOrdenes[] = [];
  public EtapasOrdenesClon: EtapasOrdenes[] = [];
  
  //generales
  public refreshOrdenes: boolean = false;
  public ordenesTrabajoInput = new ConsultaOrdenesTrabajoInput();
  public muestracomponente: boolean = true;
  public solicitudes = new Solicitudes();
  public cancelaSolicitudInput = new CancelaSolicitudInput();
  public usuario: any;
  public auxJasper: AuxJasper;
  public display: boolean = false;
  public flagShowOrdenesTrabajoFlujo: boolean = false;

  constructor(
    private consultaOrdenesTrabajoService: ConsultaOrdenesTrabajoService,
    private flujoOrdenesService: FlujoOrdenesService,
    private authenticationService: AuthenticationService,
    private registraSolicitudesService: RegistraSolicitudesService,
    private cancelaSolicitudService: CancelaSolicitudService,
    private confirmationService: ConfirmationService,
    private guardaFoliosOrdenesService: GuardaFoliosOrdenesService,
    private messageService: MessageService,
    private solicitudesService: SolicitudesService,
  ) {}

  async ngOnInit(): Promise<void>  {
    try {
      this.progressBar = true;
      this.usuario = this.authenticationService.currentUserValue;

     /* this.ordenesTrabajoInput = new ConsultaOrdenesTrabajoInput();
      await this.getAllConsultaOrdenesTrabajo(this.ordenesTrabajoInput);

      this.ConsultaOrdenesInput$.emit(this.consultaOrdenesTrabajo);*/

    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    } finally { 
      console.log("paso por ngOnInit"); 
      this.progressBar = false;
    }
  };

  async getAllConsultaOrdenesTrabajo(OrdenesTrabajoInput) {
    try {

      this.consultaOrdenesTrabajo = [];
      this.progressBar = true;

      await this.authenticationService.getUserByToken();
      OrdenesTrabajoInput.idUsuario = this.authenticationService.currentUserValue.id;

      const datoRetorno = await this.consultaOrdenesTrabajoService.getAll(OrdenesTrabajoInput).toPromise();

      for (var i = 0, len = datoRetorno?.length; i < len; ++i){
        let element:ConsultaOrdenesTrabajo = JSON.parse(datoRetorno[i].renglon)
        element.fechaAlta = new Date(element.fechaAlta);
        this.consultaOrdenesTrabajo.push(element[0])
      }

      for (var i = 0, len = this.consultaOrdenesTrabajo?.length; i < len; ++i){
        this.consultaOrdenesTrabajo[i].numRow = i;
        this.consultaOrdenesTrabajo[i].cambio = false;
        this.consultaOrdenesTrabajo[i].baja = false;
      }


    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllConsultaOrdenesTrabajo");
      this.progressBar = false;
    }
  }

  exiteModificacion(){
    //Valida si hay cambios
    try {
      let cambio = true
      if (
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].idEstatus  === this.OrdenTrabajo.idEstatus &&
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].orden      === this.OrdenTrabajo.orden &&
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].fechaAlta  === this.OrdenTrabajo.fechaAlta &&
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].idConcepto === this.OrdenTrabajo.idConcepto &&
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].nombre     === this.OrdenTrabajo.nombre &&
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].direccion  === this.OrdenTrabajo.direccion &&
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].colonia    === this.OrdenTrabajo.colonia &&
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].solicitante === this.OrdenTrabajo.solicitante &&
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].observaciones === this.OrdenTrabajo.observaciones &&
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].medidor       === this.OrdenTrabajo.medidor &&
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].telefonoOrdenes      === this.OrdenTrabajo.telefonoOrdenes &&
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].contrato      === this.OrdenTrabajo.contrato &&
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].idViaAtencion === this.OrdenTrabajo.idViaAtencion &&
        this.consultaOrdenesTrabajo[this.OrdenTrabajo.numRow].zonaOrdenes === this.OrdenTrabajo.zonaOrdenes
      ) {
        
          for (let index = 0; index < this.EtapasOrdenes.length; index++) {
             if(this.EtapasOrdenes[index].cambio){
                cambio = this.EtapasOrdenes[index].cambio
                return cambio
             };
          };
      }else{
        cambio = true
      };

      return cambio

    } catch (error) {
      
    };
   
  };

  async consultaEtapas(event:ConsultaOrdenesTrabajo){ 
    this.flagShowOrdenesTrabajoFlujo = true; 
    try {
      this.OrdenTrabajo = event;
      this.EtapasOrdenes = [] ;

      //this.consultaOrdenesTrabajo[event.numRow].etapasOrdenes = [];

      if(event.id == 0){
        //si se trata de una orden nueva se prepara una etapa nueva
        this.etapaNuevaOrden(event)
        this.EtapasOrdenesClon = this.EtapasOrdenes
      }else{
         //si se trata de una orden existente se consulta etapas que contengan
        let imput = new ConsultaOrdenesTrabajoInput()
        imput.idSolicitud = event.id;
        imput.cuentaAgua = null;
        imput.numOrdenT = null;

        const datoRetorno = await this.flujoOrdenesService.getBusquedas(imput).toPromise();

        for (var i = 0, len = datoRetorno.length; i < len; ++i){

          let element = JSON.parse(datoRetorno[i].renglon)
          let etapasOrdenesNuevo = new EtapasOrdenes()
          etapasOrdenesNuevo = {...element[0]}
    
          etapasOrdenesNuevo.numRow = i;
          etapasOrdenesNuevo.cambio = false;
          etapasOrdenesNuevo.baja   = false;

          this.EtapasOrdenes.push(etapasOrdenesNuevo)
         
        };

        //ordena por id solicitud_etapas_tramite
        this.EtapasOrdenes.sort((a, b) => a.id - b.id);
        this.EtapasOrdenesClon = this.EtapasOrdenes

      };

      // si la orden seleccionada esta cancelada no tiene caso mostrar etapas o flujo
      if(this.OrdenTrabajo.idEstatus == 4){
        this.EtapasOrdenes = [] ;
      };
      
      this.etapasOrdenesInput$.emit(this.EtapasOrdenes)

    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    }finally{
    
    };
  };


  etapaNuevaOrden(event:ConsultaOrdenesTrabajo){
    const fechaActual = Date.now()
    let etapasOrdenesNuevo: any = {}

    etapasOrdenesNuevo.numRow = 0
    etapasOrdenesNuevo.cambio = true;
    etapasOrdenesNuevo.baja = false;
    etapasOrdenesNuevo.IdDireccion  = 2;
    etapasOrdenesNuevo.numOrden = 0;
    etapasOrdenesNuevo.id = 0;
    etapasOrdenesNuevo.area = 'SIN ESTABLECER';
    etapasOrdenesNuevo.IdDireccion1 = 9;
    etapasOrdenesNuevo.departamento = 'SIN ESTABLECER';
    etapasOrdenesNuevo.IdDireccion2 = 46;
    etapasOrdenesNuevo.oficina = 'SIN ESTABLECER';
    etapasOrdenesNuevo.IdUsuarioEjecuto = null;
    etapasOrdenesNuevo.fecha = new Date(fechaActual);
    etapasOrdenesNuevo.observaciones = null;
    etapasOrdenesNuevo.IdUsuarioEjecuto = null;
    etapasOrdenesNuevo.usuario = null;
    etapasOrdenesNuevo.IdEstatus = 13;
    etapasOrdenesNuevo.estatusDesc = 'PENDIENTE';
    etapasOrdenesNuevo.id_concepto = 0;

    this.EtapasOrdenes.push(etapasOrdenesNuevo);

  }

  eventEmiteEtapa(event: EtapasOrdenes[]){
    this.EtapasOrdenes = event
    this.etapasOrdenesInput$.emit(this.EtapasOrdenes )
  }

  eventRefreschEmit(event: ConsultaOrdenesTrabajo){
    this.consultaEtapas(event);
  };

  async outputOdenesTrabajo(event: ConsultaOrdenesTrabajo){
    try {
      if(event == undefined && this.OrdenTrabajo == undefined ){
      //if(event == undefined ){
        throw new Error("No se ha seleccionado un registro que procesar");
      }; 
      let orDenTrabajo: ConsultaOrdenesTrabajo;
      if(event != undefined)
        {
            orDenTrabajo  = event ;
        }
        else {
            orDenTrabajo  = this.OrdenTrabajo;
            this.EtapasOrdenes =  this.EtapasOrdenesClon = this.childOrdenesTrabajoFlujoComponent.etapasOrdenesInput;
        }


      //let orDenTrabajo: ConsultaOrdenesTrabajo = event;
      orDenTrabajo.etapasOrdenes = this.EtapasOrdenes;

      // if(!this.exiteModificacion()){
      //   throw new Error("No existen cambios que  procesar");
      // }

      this.validacionesOrenes(orDenTrabajo);
  
      let solicitudesJson = new SolicitudesJson();
      //Agrega datos de la solicitud
      solicitudesJson.solicitudes.id                = orDenTrabajo.id
      solicitudesJson.solicitudes.idEstatus         = 13
      solicitudesJson.solicitudes.idUsuarioSolicito = this.authenticationService.currentUserValue.id;
      solicitudesJson.solicitudes.idPersonaCliente  = null
      solicitudesJson.solicitudes.idConcepto        = orDenTrabajo.idConcepto
      solicitudesJson.solicitudes.idAgua            = null;
      solicitudesJson.solicitudes.referenciaIncidente = orDenTrabajo.solicitante?.toString();
      solicitudesJson.solicitudes.direccion         = orDenTrabajo.direccion?.toString();
      solicitudesJson.solicitudes.colonia           = orDenTrabajo.colonia?.toString();
      solicitudesJson.solicitudes.telefonoOrdenes   = orDenTrabajo.telefonoOrdenes;
      solicitudesJson.solicitudes.medidor           = orDenTrabajo.medidor?.toString();
      solicitudesJson.solicitudes.idViaAtencion     = orDenTrabajo.idViaAtencion;
      solicitudesJson.solicitudes.observaciones     = orDenTrabajo.observaciones?.toString();
      solicitudesJson.solicitudes.CuentaAgua        = Number((orDenTrabajo.contrato + '').trim()); //orDenTrabajo.contrato;
      solicitudesJson.solicitudes.zonaOrdenes       = orDenTrabajo.zonaOrdenes?.toString();
      solicitudesJson.solicitudes.idColoniaIncidente    = orDenTrabajo.idColoniaIncidente;
      solicitudesJson.solicitudes.idCalleIncidente      = orDenTrabajo.idCalleIncidente;
      solicitudesJson.solicitudes.entreCalle1           = orDenTrabajo.idCalleIncidente1?.toString();
      solicitudesJson.solicitudes.entreCalle2           = orDenTrabajo.idCalleIncidente2?.toString();
 
      var auxJson = JSON.stringify({
        idDireccion:                      orDenTrabajo.idDireccion,
        direccionDescripcion:             orDenTrabajo.direccionDescripcion,
        idDireccionDepartamento:          orDenTrabajo.idDireccionDepartamento,
        direccionDepartamentoDescripcion: orDenTrabajo.direccionDepartamentoDescripcion,
        idDireccionOficina:               orDenTrabajo.idDireccionOficina,
        direccionOficinaDescripcion:      orDenTrabajo.direccionOficinaDescripcion, 
        cveCuadrilla:                     orDenTrabajo.cveCuadrilla
      });
      solicitudesJson.solicitudes.dato              = auxJson;

      //Agrega los conceptos a solicitar
      let solicitudDetalles = new SolicitudDetalles();
  
      solicitudDetalles = new SolicitudDetalles();
      solicitudDetalles.idConcepto    = orDenTrabajo.idConcepto;
      solicitudDetalles.cantidad      = 1;
      solicitudDetalles.idAgua        = null
      solicitudDetalles.costoUnitario = 0;

      solicitudesJson.solicitudDetalles.push(solicitudDetalles);

      //agrega las estapas o asignaciones manual

      for (let index = 0; index < orDenTrabajo.etapasOrdenes.length; index++) {

        const element =  orDenTrabajo.etapasOrdenes[index];
        let solicitudEtapaTramites = new SolicitudEtapaTramites();
        solicitudEtapaTramites.id               = element.id;
        solicitudEtapaTramites.idEstatus        = element.IdEstatus;
        solicitudEtapaTramites.idDireccion      = element.IdDireccion;
        solicitudEtapaTramites.idDireccion1     = element.IdDireccion1;
        solicitudEtapaTramites.idDireccion2     = element.IdDireccion2;
        solicitudEtapaTramites.idUsuarioEjecuto = element.IdUsuarioEjecuto;
        solicitudEtapaTramites.observaciones    = element.observaciones;
        solicitudEtapaTramites.fecha            = element.fecha

        solicitudesJson.solicitudEtapaTramites.push(solicitudEtapaTramites);

      };
     
  
      if(orDenTrabajo.id == 0){
        const datoRetorno = await this.registraSolicitudesService.postEditaDetalleSolicitudOrdenesTrabajo(solicitudesJson).toPromise();
        if (datoRetorno)
          {
            this.Solicitud = datoRetorno[0]; 
            await this.consultaEtapas(datoRetorno[0]);
          }

          this.muestracomponente = false;
          this.muestraMensaje.notification("Registro guardado correctamente" , "top", "center");
      }
      else{
        const datoRetorno = await this.registraSolicitudesService.SolicitudesOrdenesActualiza(solicitudesJson).toPromise();
        if (datoRetorno){
          this.muestracomponente = false;
          this.muestraMensaje.notification("Registro guardado correctamente" , "top", "center");
          this.Solicitud = datoRetorno[0];
          await this.consultaEtapas(datoRetorno[0]);
        }
      };
      
     /* this.ordenesTrabajoInput = new ConsultaOrdenesTrabajoInput();
      await this.getAllConsultaOrdenesTrabajo(this.ordenesTrabajoInput); 
      this.ConsultaOrdenesInput$.emit(this.consultaOrdenesTrabajo);*/
      this.muestracomponente = true;
     
    } catch (e) {
      this.muestraMensaje.error(e , "top", "center");
    }finally{
      console.log("paso por outputOdenesTrabajo")
    }
    
  };


  validacionesOrenes(orDenTrabajo: ConsultaOrdenesTrabajo){
    try {

      if(orDenTrabajo.idConcepto == 0 || orDenTrabajo.idConcepto == null ){
        throw new Error("Debes de indicar un tipo de orden servicio");
      }

      if(orDenTrabajo.nombre == null && orDenTrabajo.solicitante == null ){
        throw new Error("Debes de indicar nombre o solicitande para para orden");
      }

     

      /*if(orDenTrabajo.colonia == null ){
        throw new Error("Debes de indicar una colonia para la orden");
      }

      if(orDenTrabajo.telefono == null ){
        throw new Error("Debes de indicar un telefono de contacto para la orden");
      }*/




      if(orDenTrabajo.direccion == null && orDenTrabajo.contrato == null ){
        throw new Error("Debes de indicar una dirección para orden");
      }

    
      for (let index = 0; index < orDenTrabajo.etapasOrdenes.length; index++) {
        const element:EtapasOrdenes = orDenTrabajo.etapasOrdenes[index];

        if(element.IdDireccion == 0){
          throw new Error("Debes de indicar una area");
        }

        if(element.IdDireccion1 == 0){
          throw new Error("Debes de indicar un departamento");
        };

        if(element.IdDireccion1 == 0){
          throw new Error("Debes de indicar una oficina");
        };
        
      };
      

      let etapasPendientes = orDenTrabajo.etapasOrdenes.filter( x => [1,3,8].includes(x.IdEstatus));
      
      if(etapasPendientes.length >= 2){
        throw new Error("existen mas de una etapa vigente o en proceso, no esposible realizar el procesos");
      }

      
      
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por validacionesOrenes");
    };
  };

  validacionesEtapas(): boolean{

    try {

      if(this.EtapasOrdenes.length > 0){
        
        for (let index = 0; index < this.EtapasOrdenes.length; index++) {
          const element = this.EtapasOrdenes[index];

          if(element.IdDireccion == null){
            throw new Error("Debes de indicar una area");
          }
          if(element.IdDireccion1 == null){
            throw new Error("Debes de indicar un departamento");
          }
          if(element.IdDireccion2 == null){
            throw new Error("Debes de indicar una oficina");
          }
          if(element.IdUsuarioEjecuto == null){
            throw new Error("Debes de indicar un usuario para asignar");
          }
        };
      };

      return true;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por validacionesEtapas");
    };

  };


  confirmacion(rowConstaOrdenes: ConsultaOrdenesTrabajo) {

    this.confirmationService.confirm({
        message: '¿Estás seguro que quieres cancelar el trámite?',
        header: 'Confirmación',
        icon: 'pi pi-info-circle',
        accept: async () => {

          
          await this.cancelar(rowConstaOrdenes);
          this.muestraMensaje.notification("Orden Cancelada" , "top", "center");

          //this.muestracomponente = false

          /*this.ordenesTrabajoInput = new ConsultaOrdenesTrabajoInput();
          await this.getAllConsultaOrdenesTrabajo(this.ordenesTrabajoInput);

          
          this.ConsultaOrdenesInput$.emit(this.consultaOrdenesTrabajo);*/
          this.muestracomponente = true;

        },
        reject: () => {
            return;
        }
        ,acceptLabel:"Si"
    });
  
  };

  async cancelar(rowConstaOrdenes : ConsultaOrdenesTrabajo) {

    try{
      //Valida el estatus de la solicitud 
      /*const datoRetorno = await this.solicitudesService.getSingle(rowConstaOrdenes.id).toPromise();
      this.solicitudes = datoRetorno;
*/

      if(rowConstaOrdenes.idEstatus == 4){
        this.muestraMensaje.error("La solicitud ya se encuentra cancelada.", "top", "center");
        return;
      }
      if(rowConstaOrdenes.idEstatus == 2){
        this.muestraMensaje.error("La solicitud no se puede cancelar por que ya se encuentra pagada", "top", "center");
        return;
      }
      if(rowConstaOrdenes.idEstatus == 5){
        this.muestraMensaje.error("La solicitud no se puede cancelar por que ya se encuentra Terminada", "top", "center");
        return;
      }

      
       this.cancelaSolicitudInput.idSolicitud = rowConstaOrdenes.id; 
 
       await this.getCancelaSolicitudes();
     
    } catch (e){
      this.muestraMensaje.error(e.message, "top", "Center");
      if(e.response) throw { message: e.response.data};
      else throw e;
    } finally {

      console.log("Paso por Cancelar Solicitudes");
    
    }
  }

  async getCancelaSolicitudes() {
    try {

        await this.cancelaSolicitudService
        .getBusquedas(this.cancelaSolicitudInput)
        .toPromise();
      
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por  getCancelaSolicitudes");
    }
  };

  async imprimeSolicitud(orden: ConsultaOrdenesTrabajo, opcionReporte: number) {
    try {
      if(opcionReporte == 1)
        {
          this.auxJasper = new AuxJasper();
          this.auxJasper.JasperReport.nombreReporte = "Solicitud";
          this.auxJasper.JasperReport.tipo = "pdf";
          const parametroJasper = new ParametroJasper();
          parametroJasper.nombre = "_id_solicitud";
          parametroJasper.valor = orden.id.toString() + "";
          await this.auxJasper.ParametroJasper.push(parametroJasper);
          await this.showDialog();
        }


        else if(opcionReporte == 2)
          {
            this.auxJasper = new AuxJasper();
            this.auxJasper.JasperReport.nombreReporte = "014_Orden_Trabajo";
            this.auxJasper.JasperReport.tipo = "pdf";
            const parametroJasper = new ParametroJasper();
            parametroJasper.nombre = "_id_json_solicitud";
            parametroJasper.valor = orden.id.toString() + "";
            await this.auxJasper.ParametroJasper.push(parametroJasper);
            await this.showDialog();
          }




  } catch (e) {
    if (e.response) throw { message: e.response.data };
    else throw e;
  } finally {
    console.log("Paso por  imprimeSolicitud");
  }
  };

  async imprimeSolicitudMasivo(orden: number[], opcion: number) {
    try {
      const datoretorno = await this.guardaFoliosOrdenesService.add(orden).toPromise();


      this.auxJasper = new AuxJasper();
      if(opcion == 1)
      {
        this.auxJasper.JasperReport.nombreReporte = "016_Solicitud_masivo";
      }
      else if(opcion == 2)
        {
          this.auxJasper.JasperReport.nombreReporte = "014_Orden_Trabajo";
        }

        else if (opcion == 3)
        {
          if (this.childOrdenesTrabajoComponent.reportesInspeccionSelected == 1)
          {
            this.auxJasper.JasperReport.nombreReporte = "015_Inspeccion_catastro";
            const parametroJasperReporte = new ParametroJasper();
            parametroJasperReporte.nombre = "_tipo_inpeccion";
            parametroJasperReporte.valor = "1";
            await this.auxJasper.ParametroJasper.push(parametroJasperReporte);
          }
          else if (this.childOrdenesTrabajoComponent.reportesInspeccionSelected == 2)
          {
            this.auxJasper.JasperReport.nombreReporte = "017_inspeccion_micromedicion";
          }
          else if (this.childOrdenesTrabajoComponent.reportesInspeccionSelected == 3)
          {
            this.auxJasper.JasperReport.nombreReporte = "015_Inspeccion_catastro";
            const parametroJasperReporte = new ParametroJasper();
            parametroJasperReporte.nombre = "_tipo_inpeccion";
            parametroJasperReporte.valor = "2";
            await this.auxJasper.ParametroJasper.push(parametroJasperReporte);
          }
          else if (this.childOrdenesTrabajoComponent.reportesInspeccionSelected == 4)
            {
              this.auxJasper.JasperReport.nombreReporte = "014_Orden_Trabajo";
              const parametroJasperReporte = new ParametroJasper();
              parametroJasperReporte.nombre = "_tipo_inpeccion";
              parametroJasperReporte.valor = "2";
              await this.auxJasper.ParametroJasper.push(parametroJasperReporte);
            }
            else if (this.childOrdenesTrabajoComponent.reportesInspeccionSelected == 5)
              {
                  this.auxJasper.JasperReport.nombreReporte = "020_listado_orden_trabajo";
              } 

              else if (this.childOrdenesTrabajoComponent.reportesInspeccionSelected == 6)
                {
                  this.auxJasper.JasperReport.nombreReporte = "020_listado_orden_trabajo_excel";
                  this.auxJasper.JasperReport.tipo = "xlsx";
                }

                
        }

        if (this.childOrdenesTrabajoComponent.reportesInspeccionSelected != 6) {
          this.auxJasper.JasperReport.tipo = "pdf"; 
          await this.showDialog();
          }

          const parametroJasper = new ParametroJasper();
          parametroJasper.nombre = "_id_json_solicitud";
          parametroJasper.valor = datoretorno.toString() + "";
          await this.auxJasper.ParametroJasper.push(parametroJasper);
          

  } catch (e) {
    if (e.response) throw { message: e.response.data };
    else throw e;
  } finally {
    console.log("Paso por  imprimeSolicitud");
  }
  };

  showDialog() {
    this.display = true;
  }

};